export const placeholderAreaBanner = process.env.PUBLIC_URL + '/images/area-placeholder.png';
export const placeholderOfficeBanner = process.env.PUBLIC_URL + '/images/area-placeholder.png';
export const colleaguePlaceholderPhoto = process.env.PUBLIC_URL + '/images/profile-photo-placeholder.png';
export const teamPlaceholderPhoto = process.env.PUBLIC_URL + '/images/team-placeholder.png';
export const placeholderBookingBanner = process.env.PUBLIC_URL + '/images/no-booking-placeholder.svg';
